import { DrawerScrollable } from "../../../../../components/drawer-scrollable";
import { useDrawerPage } from "../../../../../providers/drawer-page.provider";
import { FormUpsertIncident } from "../components/form-upsert-incident/form-upsert-incident";
import { Box, Button, Skeleton } from "@mantine/core";
import { useUpsertIncident } from "../use-upsert-incident";
import { useIncidentQuery } from "../../../../../api/incidents.api";
import { useWorkspace } from "../../../../../providers/workspace.provider";
import { useParams } from "react-router";
import { ResourceNotFound } from "../../../../../exceptions/resource-not-found.exception";
import { LoadableContent } from "../../../../../components/loadable-content";
import { useFilterSearchParameters } from "../../../../../providers/filter.provider";
import { useFormAsyncData } from "../../../../../providers/form.provider";

export const IncidentsEditPage = () => {
  const searchParams = useFilterSearchParameters();

  const drawerProps = useDrawerPage({
    closeUrl: `/systems/incidents/?${searchParams.toString()}`,
  });
  const { incidentId } = useParams();

  if (!incidentId) throw new ResourceNotFound();

  const { workspace } = useWorkspace();

  const { data, isLoading, isFetched } = useIncidentQuery({
    workspaceId: workspace.id,
    incidentId,
  });

  const incident = data?.workspace.incident;

  const { form, isPending, handleSave } = useUpsertIncident({
    incidentId,
    onClose: drawerProps.onClose,
  });

  useFormAsyncData({
    isFetched,
    form,
    values: {
      workspaceId: workspace.id,
      applicationId: incident?.causeDeployment.application.id || "",
      teamId: incident?.team?.id,
      leaderId: incident?.leader?.id,
      detectedAt: incident?.detectedAt || "",
      resolvedAt: incident?.resolvedAt ? incident?.resolvedAt : null,
      causeDeploymentId: incident?.causeDeployment.id || "",
      fixDeploymentId: incident?.fixDeployment?.id || null,
      postmortemUrl: incident?.postmortemUrl || "",
    },
  });

  return (
    <>
      <DrawerScrollable
        {...drawerProps}
        title="Edit incident"
        actions={
          <Button type="submit" loading={isPending}>
            Update incident
          </Button>
        }
        onSubmit={handleSave}
      >
        <LoadableContent
          isLoading={isLoading}
          whenLoading={
            <Box p="md">
              <Skeleton w="100%" h={300} />
            </Box>
          }
          content={<FormUpsertIncident form={form} />}
        />
      </DrawerScrollable>
    </>
  );
};
